package csaware.utilities

object UUID {
    fun generateUuid(prefix: String = "identity--"): String {
        val ran = js("""(""+1e7+-1e3+-4e3+-8e3+-1e11).replace(/1|0/g,function(){return(0|Math.random()*16).toString(16)})""")
        return "$prefix$ran"
    }
}